<template>
    <div>
        <template v-if="transaction_fee == true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Transaction Fee </h1>
            </div>
            <div class="global-main">
                <form id="transactionFeeForm" @submit.prevent="editTransactionFeeData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Company </label>
                            <select v-model="form.companyId"  data-live-search="true" name="companyId" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('companyId') }" v-if="companies != null">
                                <option value="" selected>Select Company</option>
                                <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">
                                    {{ company.name }}
                                </option>
                            </select>
                            <has-error :form="form" field="companyId"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Transaction Type </label>
                            <select v-model="form.transactionType" name="transactionType" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('transactionType') }">
                                <option value="" selected>Select Transaction Type</option>
                                <option value="IBFT">IBFT</option>
                                <option value="BANK">LFT</option>
                              <option value="EASY_PAISA_WALLET">Easy Paisa Wallet</option>
                              <option value="SIMSIM">SIMSIM</option>
                                <option value="EASY_PAISA_CNIC">Easy Paisa CNIC</option>
                            </select>
                            <has-error :form="form" field="transactionType"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fee Type </label>
                            <select v-model="form.feeType" name="feeType" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('feeType') }">
                                <option value="" selected>Select Fee Type</option>
                                <option value="FIXED">Fixed</option>
                                <option value="PERCENTAGE">Percentage</option>
                            </select>
                            <has-error :form="form" field="feeType"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fee </label>
                            <input v-model="form.fee" type="text" name="fee" class="form-control" :class="{ 'is-invalid': form.errors.has('fee') }">
                            <has-error :form="form" field="fee"></has-error>
                        </div>
                      <div class="form-group">
                        <label> Max Charge </label>
                        <input v-model="form.maxCharge" type="text" name="maxCharge" class="form-control" :class="{ 'is-invalid': form.errors.has('maxCharge') }">
                        <has-error :form="form" field="maxCharge"></has-error>
                      </div>
                        <div class="form-group">
                            <label> FED Type </label>
                            <select v-model="form.fedType" name="fedType" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('fedType') }">
                                <option value="" selected>Select FED Type</option>
                                <option value="INCLUSIVE">Inclusive</option>
                                <option value="EXCLUSIVE">Exclusive</option>
                            </select>
                            <has-error :form="form" field="fedType"></has-error>
                        </div>
                       
                        <div class="form-group">
                            <label> Status </label>
                            <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="" selected>Select Status</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">In-active</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/transactionFee" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="transaction_fee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="transaction_fee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    companyId: "",
                    transactionType: "",
                     feeType: "PERCENTAGE",
                    fee: "",
                  maxCharge: "",
                    fedType: "EXCLUSIVE",
                    feeBear: "",
                    status: "",
                }),
                companies: [],
                transaction_fee: null,
            };
        },
        methods: {
            editTransactionFeeData() {
                this.$Progress.start();
                this.form
                    .put("/api/updateTransactionFee")
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.data.code == 200) {
                                this.resetForm();
                                this.$Progress.finish();
                                this.showToastBox("success", "Transction Fee updated successfully");
                                this.$router.push("/transactionFee");
                            } else {
                                $(this.$el).find('.selectpicker').selectpicker('refresh');
                                this.showToastBox("error", res.data.message);
                            }
                        } else {
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                        }
                    })
                    .catch((err) => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox("error", "Some error in your form data");
                    });
            },
            resetForm() {
                this.form.companyId = "";
                this.form.transactionType = "";
                this.form.feeType = "";
                this.form.fee = "";
                this.form.maxCharge = "";
                this.form.fedType = "";
                this.form.status = "";
            },
            getEditTransactionFeeData() {
                axios
                    .get("/api/editTransactionFee/" + this.$route.params.id)
                    .then((res) => {
                        if (res.status == 200) {
                            this.companies = res.data.companies;
                            this.form.id = res.data.record.id;
                            this.form.companyId = res.data.record.companyId;
                            this.form.transactionType = res.data.record.transactionType;
                            this.form.feeType = res.data.record.feeType;
                            this.form.fee = res.data.record.fee;
                            this.form.maxCharge = res.data.record.maxCharge;
                            this.form.fedType = res.data.record.fedType;
                            this.form.status = res.data.record.status;
                            this.$Progress.finish();
                            setTimeout(function(){
                            $('.selectpicker').selectpicker('refresh');

                            },0)

                        } else {
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                        }
                    })
                    .catch((err) => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox("error", "Some error in your form data");
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("transaction_fee")
                .then((result) => {
                    this.transaction_fee = result.transaction_fee;
                })
                .then((result) => {
                    if (this.transaction_fee == true) {
                        this.getEditTransactionFeeData();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                    setTimeout(() => {
                        $('.selectpicker').selectpicker('refresh');
                    }, 1000);
                });
        },
    }
</script>
